<template>
  <div
    class="container-fluid bg-secondary border-0 mb-0 shadow-none projectGantt"
  >
    <div class="row no-gutters border row--overflow">
      <div :class="{'pt-3': editMode}" class="bg-white col-md-12 col-sm-12 border-right col-mod">
        <div class="table-responsive table-responsive--mod">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th
                  scope="col"
                  style="min-width:500px; height:27px;"
                  class="py-0"
                >
                  Archived Projects
                </th>
                
              </tr>
            </thead>
            <tbody class="list overflow-auto" v-if="archivedTasks">
              <tr
                v-for="(task, ind) in archivedTasks"
                :key="ind"
                @click="$emit('taskClick', task)"
                :class="{ active: true }"
                class="editable"
              >
                <td scope="row">
                  <div class="media-body">
                    <div
                      class="gantt_task_line gantt_bar_task position-relative sm-gantt_task_line"
                      style="height: 45px; line-height: 45px; width:100%; background-color:gray"
                    >
                      <div class="gantt_task_progress_wrapper">
                        <div
                          class="gantt_task_progress"
                          style="width: 0px;"
                        ></div>
                      </div>
                      <div class="gantt_task_content" v-html="task.name"/>
                      <!-- <div class="gantt_side_content gantt_right">
                        <span
                          data-toggle="tooltip"
                          data-trigger="hover"
                          title="Michael Simonetti"
                          class="d-flex mr-1"
                          ><a
                            href="#"
                            data-user="2"
                            class="avatar avatar-name avatar-sm avatar-assigned-by  text-xl text-white rounded-circle bg-danger"
                            data-target="offcanvasFrom"
                            data-offcanvasfrom="offcanvas"
                            data-role-id="2"
                            data-role-name="CREATOR"
                            >MS<span
                              data-toggle="tooltip"
                              data-trigger="hover"
                              title="Admin User"
                              class="d-flex mr-1"
                            ></span></a
                          ><a
                            href="#"
                            class="avatar avatar-name avatar-sm avatar-assigned-to   bg-danger text-xl text-white rounded-circle"
                            data-target="offcanvasFrom"
                            data-offcanvasfrom="offcanvas"
                            data-user="6"
                            data-role-id="8"
                            data-role-name="ASSIGNEE"
                            ><img
                              src="https://localhost:8000/storage/profile_pic/profile-pic-1612329544.png"
                              class="rounded-circle"
                            /> </a
                          >
                          </span
                        >
                      </div> -->
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import HtmlEditor from "../../components/Inputs/HtmlEditor.vue";
import AssetThread from "./AssetThread.vue";
import { isMobile } from "mobile-device-detect";
export default {
  props: ["tasks"],
  components: { AssetThread, HtmlEditor },
  name: "Archived",
  data() {
    return {
      isMobile: isMobile,
      editMode: false
    };
  },
  computed: {
    ...mapState("user", ["profile"]),
   
    archivedTasks() {
      // return (
      //   (this.tasks && this.tasks.data.filter(t => t.status == "CLOSED")) || []
      // );

      return this.tasks && this.tasks.data || []
    }
  },
    
  mounted() {},
  methods: {
    ...mapActions("task", ["updateTask"]),
    ...mapMutations(["setGanttRender", "setLoading"]),
    async saveTask(task, refresh = true) {
      task.parent_id = this.project.id;
      if (task.id) {
        try {
          let res = await this.updateTask(task);
          //await this.fetchTask(this.task.id)
          //await this.fetchTask(task.id, refresh);
          this.setGanttRender();
          this.$emit("taskCreated", refresh);
          this.$snack.success({text: "Task Has been updated successfully"});
        } catch (e) {
          console.log("Erro task save ", e);
          this.$snack.error("Error occured while updating task");
        }
      }
    },

    

    
  }
};
</script>

<style lang="scss" scoped>
.select-small.el-select .el-input .el-input__inner {
  height: 31px;
}
.table td {
  padding: 0.3rem;
} 
</style>

<style lang="scss" scoped>
.sm-gantt_task_line {
  height: 31px !important;
  line-height: 31px !important;
  .gantt_task_content {
    font-size: 13px;
    line-height: 31px;
  }
}
.media-body {
  .btn-sm {
    padding: 0.344rem 0.5rem !important;
  }
}
.total-price {
  h2 {
    font-size: 0.875rem !important;
    margin-bottom: 0;
  }
}
.close-btn-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 25px;
  button {
    background: transparent;
    border: 0;
    padding: 0;
    i {
      color: #2dce89;
    }
    &:hover {
      opacity: 0.5;
    }
  }
}
.mobile-view-table {
  margin-bottom: 0;
  border-bottom: 1px solid #e9ecef;
  tbody.list {
    tr {
      th.project {
        white-space: pre-wrap;
      }
      td.edit {
        width: 40px;
      }
    }
  }
}
.ul-tasks-edit {
  padding: 15px;
  padding-bottom: 0;
  li {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &.wrap{
      input{
         height: calc(0.45em + 1.25rem + 17px);
      }
      li{
        flex: 0 0 50%;
        max-width: 50%;
        &:first-child{
          padding-right: 5px;
        }
        &:last-child{
          padding-left: 5px;
        }
      }
    }
    label {
      font-weight: 500;
      margin-bottom: 2px;
    }
  }
}
@media only screen and (max-width: 768px){
    .ul-tasks-edit {
      li.wrap{
          input{
           height: calc(0.45em + 1.25rem + 16px);
        }   
      }
    }
  }
</style>
